module.exports = {
  localeName: 'en-US'
};
